import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../components/procedure/selectors'
import { setInputRows } from '../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../components/procedure/store/procedure.types'
import { getIntubationSelector } from '../selectors'
import { IntubationConstants } from '../store/intubation.constants'
import { IIntubationState } from '../store/intubation.types'

export function* setDecisiontoManageDateTime() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const intubationState: IIntubationState = yield select(getIntubationSelector)
  const { inputRows } = procedureState
  const { decisiontoManageTime, decisiontoManageDate } = intubationState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === IntubationConstants.SET_DECISION_TO_MANAGE_DATE_TIME) {
        //@ts-ignore
        input.props.time = decisiontoManageTime
        //@ts-ignore
        input.props.date = decisiontoManageDate
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setDecisiontoManageDateTimeSaga() {
  yield takeLatest(
    [
      IntubationConstants.SET_DECISION_TO_MANAGE_DATE,
      IntubationConstants.SET_DECISION_TO_MANAGE_TIME,
      IntubationConstants.SET_DECISION_TO_MANAGE_DATE_TIME,
    ],
    setDecisiontoManageDateTime
  )
}
